import styled from "styled-components";

export const InstagramPostsContainer = styled.div`
  width: 100%;
  margin: 0 auto;

  .react-multi-carousel-track {
    display: flex !important;

    @media (min-width: 1050px) {
      gap: 40px !important;
    }
  }
`;

export const PostCard = styled.div`
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 357px;
  transition: transform 0.2s ease;
  &:hover {
    transform: translateY(-5px);
  }

  .post-header {
    padding: 15px;
    border-bottom: 1px solid #f0f0f0;
  }
  .post-text {
    padding: 15px;
    font-size: 1em;
    color: #333;
    line-height: 1.4;
  }
  .post-reviews {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
    background-color: #f9f9f9;
    border-top: 1px solid #f0f0f0;
  }
`;
